import React from 'react';
import styled from 'styled-components';
import Imgix from 'shared/components/imgix';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

type KioskProLogoProps = {
  className?: string;
  maxHeight?: string;
};

export function KioskProLogo({ className, maxHeight }: KioskProLogoProps): JSX.Element {
  const {
    dispensary: { logoImage, name },
  } = useDispensary();

  return (
    <LogoContainer className={className} data-testid='kiosk-pro-logo-container'>
      <Logo src={logoImage} alt={name} $maxHeight={maxHeight} />
    </LogoContainer>
  );
}

const LogoContainer = styled.div`
  padding: 20px;

  @media (orientation: portrait) {
    padding-top: 60px;
  }
`;

const Logo = styled(Imgix)<{ $maxHeight?: string }>`
  display: block;
  max-height: ${({ $maxHeight }) => $maxHeight ?? '64px'};
  width: 100%;
  object-fit: contain;
`;
